/**
 * Canonical employee type codes and display labels (Dexpert HRMS).
 */

const LEGACY_ALIASES = {
  permanent_benfish: 'permanent',
  contract_benfish: 'contractual',
  benfish_staff: 'permanent',
  benfish_employee: 'permanent',
  consultant_benfish: 'consultant',
};

const DISPLAY_LABELS = {
  permanent: 'Permanent',
  permanent_government: 'Permanent (Government)',
  contractual: 'Contractual',
  consultant: 'Consultant',
};

export function normalizeEmployeeType(value) {
  if (!value) return '';
  const key = String(value).trim().toLowerCase();
  return LEGACY_ALIASES[key] || key;
}

export function displayEmployeeType(value) {
  if (!value) return '';
  const canonical = normalizeEmployeeType(value);
  return DISPLAY_LABELS[canonical] || canonical.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export const EMPLOYEE_TYPE_FILTER_OPTIONS = [
  { value: 'permanent', label: 'Permanent' },
  { value: 'contractual', label: 'Contractual' },
  { value: 'consultant', label: 'Consultant' },
];

export const EMPLOYEE_TYPE_FORM_OPTIONS = [
  { value: 'permanent', label: 'Permanent' },
  { value: 'contractual', label: 'Contractual' },
  { value: 'consultant', label: 'Consultant' },
];

export const TYPE_CODE_MAP = {
  PERM: 'permanent',
  CONT: 'contractual',
  CONS: 'consultant',
};
